var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSharpCorners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0265 12C21.159 12.133 40.4226 28.9224 43.2843 32.0621C43.7526 32.5673 44.0088 33.2345 43.9998 33.9246V45.6053C43.9998 45.9198 43.9381 46.2312 43.8182 46.5217C43.6984 46.8123 43.5227 47.0762 43.3013 47.2986C43.0798 47.521 42.8169 47.6974 42.5276 47.8177C42.2383 47.938 41.9282 48 41.615 48H23.3848C22.7523 48 22.1457 47.7477 21.6985 47.2986C21.2512 46.8495 21 46.2404 21 45.6053V12H21.0265Z",
    fill: "#123660"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 4.00213C16.5347 4.00213 3.99978 16.5384 3.99978 32C3.99978 47.4616 16.5347 59.9979 32 59.9979C47.4653 59.9979 60.0002 47.4616 60.0002 32C60.0002 16.5384 47.4653 4.00213 32 4.00213ZM0 32C0 14.3257 14.3281 0 32 0C49.6719 0 64 14.3257 64 32C64 49.6743 49.6719 64 32 64C14.3281 64 0 49.6743 0 32Z",
    fill: "#FF0033"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1586 56L8 10.8715L10.8414 8L55 53.1285L52.1586 56Z",
    fill: "#FF0033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSharpCorners);
export default __webpack_public_path__ + "static/media/icon-sharp-corners.659e6afe22ea7e6e154c2c09b5497725.svg";
export { ForwardRef as ReactComponent };